<script>
import PackageAddonBody from './package-addon-component'
export default {
  name: 'PackageProdBody',
  components: { PackageAddonBody },
  props: {
    componentDataObject: {
      type: Array,
      default() {
        return []
      },
    },
    fraudPlusPackageDetails: {
      type: Array,
      default() {
        return []
      },
    },
    disabledSection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fraudPlusProductsData: [],
    }
  },
  computed: {},
  mounted() {
    this.fraudPlusProductsData = this.fraudPlusPackageDetails
      .filter(function(i, n) {
        return i.checked === true
      })
      .map(function(p, q) {
        return p.indexValue
      })
  },
  methods: {
    onChangeProds(evt) {
      this.fraudPlusPackageDetails
        .filter((x) => evt.includes(x.indexValue))
        .forEach(function(item) {
          item.checked = true
        })
      this.fraudPlusPackageDetails
        .filter((x) => !evt.includes(x.indexValue))
        .forEach(function(item) {
          item.checked = false
          item.fraudPlusProductAddOns.filter(function(additem, index) {
            additem.checked = false
          })
        })

      // let that = this
      // for (let inx = 0; inx < that.fraudPlusPackageDetails.length; inx++) {
      //   if (evt.indexOf(inx) === -1) {
      //     that.fraudPlusPackageDetails[inx].fraudPlusProductAddOns.filter(
      //       function(item, index) {
      //         item.checked = false
      //       }
      //     )
      //   }
      // }
    },
  },
}
</script>
<template>
  <b-card-body>
    <b-form-checkbox-group
      v-model="fraudPlusProductsData"
      :options="fraudPlusPackageDetails"
      class="mb-3 check-box-group"
      value-field="indexValue"
      text-field="fraudPlusProductName"
      size="lg"
      :disabled="disabledSection"
      @change="onChangeProds"
    >
    </b-form-checkbox-group>
    <div
      v-for="selectedProduct in fraudPlusProductsData"
      :key="selectedProduct"
      class="accordion"
      role="tablist"
    >
      <b-card
        v-if="
          fraudPlusPackageDetails[selectedProduct].fraudPlusProductAddOns
            .length > 0
        "
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="'product-accordion-' + selectedProduct"
            block
            variant="default"
            class="text-left d-flex"
            :class="$style.nooutline"
          >
            {{ fraudPlusPackageDetails[selectedProduct].fraudPlusProductName }}
            <strong aria-hidden="true" class="ml-auto">
              <i class="fa fa-angle-up"></i>
              <i class="fa fa-angle-down"></i>
            </strong>
          </b-button>
        </b-card-header>
        <b-collapse
          :id="'product-accordion-' + selectedProduct"
          :visible="
            fraudPlusPackageDetails[selectedProduct].fraudPlusProductAddOns
              .length > 0
          "
          role="tabpanel"
        >
          <PackageAddonBody
            :fraud-plus-package-details="
              fraudPlusPackageDetails[selectedProduct].fraudPlusProductAddOns
            "
          ></PackageAddonBody>
        </b-collapse>
      </b-card>
    </div>
  </b-card-body>
</template>
<style lang="scss" module>
@import '@design';
.nooutline {
  font-weight: bold;
  color: #000 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
